import {
  fieldExistingCustomer,
  fieldOrderRequestType,
  newBusinessAppsToTCO
} from '../../utils/constant';
import { getFieldValue } from '../utils';

const MicrosoftCloudAdvisoryServicesSection = (formFields, fieldName) => {

  const orderRequestTypeValue = getFieldValue(
    fieldOrderRequestType,
    formFields
  );

  if (
    fieldName === fieldExistingCustomer &&
    orderRequestTypeValue !== newBusinessAppsToTCO
  ) {
    formFields[fieldExistingCustomer].isRequired = false;
    return true;
  } else if (fieldName === fieldExistingCustomer) {
    formFields[fieldExistingCustomer].isRequired = true;
  }
};

export default MicrosoftCloudAdvisoryServicesSection;
